<div class="newsletter-container" [ngStyle]="{'background-color': backgroundColor, padding: linePadding}">
    <div>
      <vsf-title-box
        [titleInfo]="titleInfo"
        [forComponent]="true">
      </vsf-title-box>
    </div>
    <ng-container *ngIf="type === 'raw'">
      <img *ngIf="backgroundImage"
        [src]="backgroundImage | assetPreview:'full':'webp'"
        [alt]="backgroundImage.customFields?.altText ? backgroundImage.customFields?.altText : 'Background Image'"
        class="background-image"
        [style.object-position]="backgroundImage | focalPoint"
      >
      <div *ngIf="backgroundImage && shadowOpacity"
        class="absolute inset-0 bg-gray-500 pointer-events-none"
        style="z-index: 2;"
        [style.opacity]="shadowOpacity">
      </div>
      <div class="newsletter-content">
        <form (ngSubmit)="onSubmit()">
          <input type="email" placeholder="Enter your email" [(ngModel)]="email" name="email" required>
          <button type="submit">Submit</button>
        </form>
      </div>
    </ng-container>
    <ng-container *ngIf="type === 'omnisend' && omnisendFormReady">
      <div [ngStyle]="{'background-color': backgroundColor}">
        <div [id]="omnisendFormId"></div>
      </div>
    </ng-container>
</div>